// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1w1G8","search":"Settings_search__2SspB","filter":"Settings_filter__bYZw2"};